import type {
  CreateResponseProjectResponseDTO,
  FindAllProjectResponsesResponseDTO,
  FindOneResponseProjectResponseDTO,
} from '../../../entities/ProjectResponse';
import { magellanClient } from '../../../infra/axios';
import type { CreateResponseProjectRequestDTO } from './dto';

export async function getResponseProjects(): Promise<FindAllProjectResponsesResponseDTO> {
  const response =
    await magellanClient.get<FindAllProjectResponsesResponseDTO>(
      '/responseProjects',
    );

  return response.data;
}

export async function createResponseProject(
  payload: CreateResponseProjectRequestDTO,
): Promise<CreateResponseProjectResponseDTO> {
  const response = await magellanClient.post<CreateResponseProjectResponseDTO>(
    '/responseProjects',
    payload,
  );
  return response.data;
}

export async function getResponseProjectById(
  id: number,
): Promise<FindOneResponseProjectResponseDTO> {
  const response = await magellanClient.get<FindOneResponseProjectResponseDTO>(
    `/responseProjects/${id}`,
  );

  return response.data;
}
